import { isAnyOf } from '@reduxjs/toolkit';
import transformWishlistModel from '../../utils/transformWishlistModel.js';
import { createGenericSlice } from '../genericSlice.js';
import initialState from './initialState.js';
import { addProductsToWishlist, removeProductsFromWishlist } from './thunks.js';
import 'lodash/set';
import '../../types/index.js';
import '../../checkout-Ee1eEXQH.js';
import '../../menu-0TyOg98i.js';
import '../../product-_pRduMz7.js';
import '../../modal-6vnX5SO3.js';
import '../../RemoveProductsFromWishlist-WCaYiZlq.js';
import '../../requestsCollection-_VRM28HJ.js';
import '../../graphqlRequestClient-3KYHZKVm.js';
import 'react';
import 'graphql-request';
import 'lodash/cloneDeep';
import 'lodash/get';
import '../../services/auth/index.js';
import '../../utils/logToSlack.js';
import '../../utils/cookies.js';
import 'cookies-next';
import '../../cookies-l-jEMp6P.js';
import '../../currency-_kacFJHO.js';
import '../../language-BHHwgtQp.js';
import '../../payment-YC9H491Y.js';
import '../../utils/isBot.js';
import '../../utils/currency.js';
import '../../context/index.js';
import 'next/server';
import '../../index-Oip0gjfj.js';
import 'next/router';
import '../../helpers-kA_hdoOI.js';
import '../../utils/product.js';
import '../../paths-ZKN3m62_.js';
import 'lodash';
import '../../utils/fetchPolicyLookup.js';
import '../../utils/error.js';
import '../../serverErrors-_VHsjhgw.js';
import '../../utils/logger.js';
import '../../utils/logToRelic.js';
import '../../wishlist-foOHzuD7.js';

const wishlistSlice = createGenericSlice({
    name: 'wishlist',
    initialState,
    reducers: {
        createWishlist: (state, { payload }) => {
            state.wishlists = payload.map(wishlist => transformWishlistModel(wishlist));
        },
        clearWishlist: state => {
            state.wishlists = [];
        },
        removeProductFromWishlist: (state, { payload: productId }) => {
            state.wishlists = state.wishlists.map((wishlist, index) => {
                if (index !== 0)
                    return wishlist;
                const filteredWishlist = wishlist.items.filter(item => item.id !== productId);
                const currentWishlistItemsCount = wishlist.items.length;
                const filteredWihslistItemsCount = filteredWishlist.length;
                let { itemsCount } = wishlist;
                if (filteredWihslistItemsCount < currentWishlistItemsCount) {
                    itemsCount -= 1;
                }
                return {
                    ...wishlist,
                    items: filteredWishlist,
                    itemsCount,
                };
            });
        },
    },
    extraReducers: builder => {
        builder.addMatcher(isAnyOf(addProductsToWishlist.fulfilled, removeProductsFromWishlist.fulfilled), (state, { payload }) => {
            state.wishlists = state.wishlists.map(wishlist => wishlist.id === payload.id ? transformWishlistModel(payload) : wishlist);
        });
    },
});
const { createWishlist, clearWishlist, removeProductFromWishlist } = wishlistSlice.actions;
var index = wishlistSlice.reducer;

export { clearWishlist, createWishlist, index as default, removeProductFromWishlist };
//# sourceMappingURL=index.js.map
